import api from '@/services/Api';
import Rezept from '@/types/Rezept';
import { successSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import { RezepteState, RootState } from '@/store/types';

export type RezepteFilter = { gueltig: string };
export type LoadRezeptePayload = { filter: RezepteFilter };
export type UpdateRezeptPayload = { rezept: Rezept; filter: RezepteFilter };
export type DeleteRezeptPayload = { rezept: Rezept; filter: RezepteFilter };

type Context = ActionContext<RezepteState, RootState>;

export const rezepte: Module<RezepteState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            rezepte: false,
        },
        rezepte: [],
    },
    actions: {
        loadRezepte({ commit }: Context, payload?: LoadRezeptePayload): void {
            commit('setLoadersRezepte', true);
            commit('setRezepte', []);

            api.post('verwaltung/rezepte/load', payload)
                .then((response: AxiosResponse) => commit('setRezepte', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersRezepte', false));
        },
        updateRezept({ commit, dispatch }: Context, { rezept, filter }: UpdateRezeptPayload): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/rezepte/speichern', rezept)
                .then(() => {
                    successSwal('Rezept', 'gespeichert');
                    dispatch('loadRezepte', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteRezept({ commit, dispatch }: Context, { rezept, filter }: DeleteRezeptPayload): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/rezepte/loeschen', rezept)
                .then(() => {
                    successSwal('Rezept', 'gelöscht');
                    dispatch('loadRezepte', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
    },
    mutations: {
        setRezepte(state: RezepteState, payload: Partial<Rezept>[]): void {
            state.rezepte = payload.map((data) => new Rezept(data));
        },
        setDialogsDetail(state: RezepteState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: RezepteState, visible: boolean): void {
            state.loaders.save = visible;
        },
        setLoadersDelete(state: RezepteState, visible: boolean): void {
            state.loaders.delete = visible;
        },
        setLoadersRezepte(state: RezepteState, visible: boolean): void {
            state.loaders.rezepte = visible;
        },
    },
};
